<template>
  <p v-if="text" class="!whitespace-pre-line">
    <template v-if="containsLinks">
      <template v-for="(message, index) in vector">
        <template v-if="checkForLink(message)">
          <a :key="index" :href="formatUrl(message)" target="_blank">{{ message }}</a>
          {{ ' ' }}
        </template>
        <template v-else>
          {{ message }}
        </template>
      </template>
    </template>
    <template v-else>
      {{ text }}
    </template>
  </p>
</template>

<script>
import { defineComponent } from 'vue';

const comp = defineComponent({
  name: 'MessageText',
  props: {
    text: { type: String, default: '' },
  },
  data() {
    return {
      pattern:
        /((http|https|ftp):\/\/\S+)|(www\.)?[\w-_]+\.(com|org|net|ca|co|uk|us|fr|my|ai|io|app|gov)+\b([\w-@:%+.~#?&//=]*)/i,
    };
  },
  computed: {
    containsLinks() {
      return this.text.match(this.pattern)?.length > 0;
    },
    vector() {
      // lookahead zero-length assertions - split on spaces keep them
      return this.text.split(/(?=\s)/);
    },
  },
  methods: {
    checkForLink(text) {
      const linkRegex = new RegExp(this.pattern);
      // exclude email address or truncated urls
      const excludeRegex = /(.*(…))|(.*\.{3,})|(.*@.*)/;

      return linkRegex.test(text) && !excludeRegex.test(text);
    },
    formatUrl(link) {
      const rootRegex = /(.*\/\/\S+)/;
      if (!rootRegex.test(link)) {
        return `//${link.trim()}`;
      }
      return link;
    },
  },
});
export default comp;
</script>
